// extracted by mini-css-extract-plugin
export default {"container":"Z_4rVfmt","wrapper":"Dbr6nKeo","slide":"YJqx85L3"};